<template>
  <v-widget
    :title="$t('Products')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-data-table
        v-model="taxonomy.products"
        :loading="loading"
        :headers="headers"
        :items="products"
        :rows-per-page-text="$t('Rows per page')"
        :pagination.sync="pagination"
        :total-items="total"
        show-select
        select-all
        class="elevation-1"
        item-key="id"
      >
        <v-progress-linear
          slot="progress"
          color="primary"
          indeterminate
        />

        <template v-slot:items="props">
          <taxonomy-product-data-table-row
            :props="props"
          />
        </template>
        <template v-slot:pageText="props">
          <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
        </template>
      </v-data-table>
    </div>
  </v-widget>
</template>

<script>
import TaxonomyProductDataTableRow from '../TaxonomyProductDataTableRow'
import ProductService from '@/modules/Products/service.js'

export default {
  name: 'TaxonomySingleProducts',

  components: {
    TaxonomyProductDataTableRow
  },

  props: {
    taxonomy: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'name'
      },
      total: 0,
      loading: false,
      products: []
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('SKU'), value: 'sku' },
        { text: this.$t('Name'), value: 'name' }
      ]
    }
  },

  watch: {
    pagination: function () {
      this.getProducts()
    }
  },

  methods: {
    async getProducts () {
      this.loading = true
      const res = await ProductService.loadOnlyProducts(this.pagination)
      this.products = res.collection
      this.total = res.page.total
      this.loading = false
    }
  }
}
</script>
